import React from 'react'
import { connect } from "react-redux";
import styled, { css } from 'styled-components'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import { rgba } from 'polished'

import InputText from '../InputText'
import InputEmail from '../InputEmail'
import Submit from '../Submit'

import { container, heading, bgImage, button, bgIcon, hoverState, padding } from "../../styles/global"
import { resolveHeaderType } from "../../styles/fonts";
import { width, media } from "../../styles/utils"
import { grey,red } from '../../styles/colors'

import { fetchSettings, getSettings, updateSettings } from '../../store/settings';

import close from '../../assets/icons/hamburger-close.svg'
import closeMobile from '../../assets/icons/close-black.svg'
//import banner from '../../assets/images/competition-banner.png'

class Competition extends React.Component {

    state = {
        active: false,
        firstName: '',
        firstNameError: false,
        firstNameErrorMessage: 'This field is required.',
        lastName: '',
        lastNameError: false,
        lastNameErrorMessage: 'This field is required.',
        email: '',
        emailError: false,
        emailErrorMessage: 'This field is required.',
        postcode: '',
        postcodeError: false,
        postcodeErrorMessage: 'This field is required.',
        showErrors: false,
        formSuccess: false,
        formError: false,
        formErrorMessage: ''
    }

    componentDidMount = () => {
        const self = this;

        setTimeout(() => {
            self.setState({
                active: true
            })
        }, 5000);
    }

    handleFieldChange = (key, value) => {
        this.setState({
            [key]: value
        })
    }

    toggleSignup = () => {
        const { updateSettings } = this.props;

        updateSettings({
            signupActive: !this.state.active
        })
    }

    componentDidUpdate = (prevProps, prevState) => {
        const { settings } = this.props;

        //console.log(settings.signupActive, prevProps.settings.signupActive)

        if (settings.signupActive !== prevProps.settings.signupActive) {

            this.setState({
                active: settings.signupActive
            })
            
            document.body.style.overflowY = settings.signupActive ?  'hidden' : 'auto';
        }
    }
    
    validateEmail = () => {        
        let val = this.state.email;

        var emailTest = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailTest.test(val)) {
            this.setState({
                emailError: false,
                emailErrorMessage: ''
            })
            return true;
        } else {
            this.setState({
                emailError: true,
                emailErrorMessage: 'Please input a valid email address.'
            })
            return false;
        }
    }

    validateName = (field) => {
        const val = this.state[field]

        if (val.length > 0) {
            this.setState({
                [field+'Error']: false,
                [field+'ErrorMessage']: ''
            })
            return true;
        } else {
            this.setState({
                [field+'Error']: true,
                [field+'ErrorMessage']: `This field is required.`
            })
            return false;
        }
    }

	handleSubmit = () => {
        let valid = false;

        valid = this.validateEmail(this.state.email)
        valid = this.validateName('firstName')
        valid = this.validateName('lastName')
        valid = this.validateName('postcode')

        if (valid) {

            addToMailchimp(this.state.email,{
                FNAME: this.state.firstName,
                LNAME: this.state.lastName,
                MMERGE3: this.state.postcode
            }).then(data => {

                if (data.result=='success') {
                    this.setState({formSuccess: true})
                }

                if (data.result=='error') {
                    this.setState({
                        formError: true,
                        formErrorMessage: data.msg
                    })
                } 
            })
        }
    }

	render() {
        const { active } = this.state;
        const { data } = this.props;

		return (
            <Wrapper
                open={active}
             >

                <Content>
                    <Banner
                        src={`https://${data.mc_signup_image}`}
                    />

                    {!this.state.formSuccess && (

                        <React.Fragment>
                            
                            <Subheading>
                                {data.mc_signup_text}
                            </Subheading>

                            <Form>

                                <Fields>
                                    <Name
                                        label="First Name"
                                        type={'name'}
                                        placeholder="First Name"
                                        value={this.state.firstName}
                                        onBlur={(e) => this.validateName('firstName')}
                                        onChangeValue={(e) => this.handleFieldChange('firstName',e.target.value)}
                                        error={this.state.firstNameError}
                                        errorMessage={this.state.firstNameErrorMessage}
                                        showErrors={this.state.showErrors}
                                    />

                                    <Name
                                        label="Last Name"
                                        type={'name'}
                                        placeholder="Last Name"
                                        value={this.state.lastName}
                                        onBlur={(e) => this.validateName('lastName')}
                                        onChangeValue={(e) => this.handleFieldChange('lastName',e.target.value)}
                                        error={this.state.lastNameError}
                                        errorMessage={this.state.lastNameErrorMessage}
                                        showErrors={this.state.showErrors}
                                    />

                                    <Email
                                        label="Email"
                                        placeholder="Email"
                                        value={this.state.email}
                                        onBlur={(e) => this.validateEmail()}
                                        onChangeValue={(e) => this.handleFieldChange('email',e.target.value)}
                                        error={this.state.emailError}
                                        errorMessage={this.state.emailErrorMessage}
                                        showErrors={this.state.showErrors}
                                    />

                                    <Postcode
                                        label="Postcode"
                                        placeholder="Postcode"
                                        value={this.state.postcode}
                                        onBlur={(e) => this.validateName('postcode')}
                                        onChangeValue={(e) => this.handleFieldChange('postcode',e.target.value)}
                                        error={this.state.postcodeError}
                                        errorMessage={this.state.postcodeErrorMessage}
                                        showErrors={this.state.showErrors}
                                    />

                                    <SubmitForm
                                        label="Sign up"              
                                        handleSubmit={this.handleSubmit}
                                    />
                                </Fields>                        
                            </Form>
                        </React.Fragment>
                    )} 

                    {this.state.formSuccess && (
                        <Success>You successfully entered the competition. Please confirm your subscription in the email we sent you.</Success>
                    )}     

                    {this.state.formError && (
                        <Error 
                            dangerouslySetInnerHTML={{__html: this.state.formErrorMessage }}
                        />      
                    )}
                </Content>

                <Close
                    onClick={this.toggleSignup}
                />

            </Wrapper>
		)
	}
}

const Wrapper = styled.div`
    background: ${rgba('black', 0.85)};
	height: 100vh;
	width: 100vw;

	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 12;

	pointer-events: none;
	opacity: 0;
	transition: opacity 650ms ease;
    box-sizing: border-box;

	display: flex;
	justify-content: center;
    align-items: center;

	will-change: opacity;
	transform: translate3d(0,0,0);

    padding: 0 57px;

    ${media.phone`
        padding: 0;
    `}

	${props => {
		if (props.open) return css`
			opacity: 1;
			pointer-events: all;
		`
	}}
`

const Content = styled.div`
    max-width: 540px;
    width: 100%;
    background: white;
    border-bottom: 2px solid black;
    padding-bottom: 30px;

    ${media.phone`
        height: 100%;
    `}
`

const Subheading = styled.div`
    font-family: 'GT America Expanded Bold';
    font-size: 20px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    padding: 0 28px;
    text-transform: uppercase;
    margin-top: 26px;


    ${media.phone`
        font-size: 14px;
        box-sizing: border-box; 
        line-height: 20px;
    `}
`

const Form = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;
    margin-top: 24px;

    ${media.phone`
        padding: 0 20px;
        box-sizing: border-box; 
    `}
`

const Banner = styled.div`
    background-image: url(${props => props.src});
    height: 250px;
    width: 100%;
    ${bgImage}

    ${media.phone`
        height: 180px;
    `}
`

const fieldStyle = css`
    height: 50px;

    &, &::placeholder {
        font-size: 12px;
        text-align: center;
        font-family: 'GT America Expanded Bold';
        text-transform: uppercase;
        text-align: left;
    }

    &::placeholder {
        opacity: 0.5;
    }
`

const Name = styled(InputText)`
    flex: 0 1 50%;
    ${fieldStyle}
`
const Postcode = styled(InputText)`
    ${fieldStyle}
`
const Email = styled(InputEmail)`
    ${fieldStyle}
`
const SubmitForm = styled(Submit)`
    height: 50px;
    width: 100%;
    background: black;
    color: white;

    appearance: none;
    border: none;

    font-size: 12px;
    text-align: center;
    font-family: 'GT America Expanded Bold';
    text-transform: uppercase;
`

const Fields = styled.div`
    max-width: 480px;
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    .error {
        font-size: 12px;
        text-align: center;
        font-family: 'GT America Expanded Bold';
        text-transform: uppercase;
        text-align: left;
    }
    
    > * {
        &:not(:last-child) {
            margin-bottom: 10px;
        }
    }

    > *:nth-child(1),
    > *:nth-child(2) {
        flex: 0 1 calc(50% - 5px);
    }

    > *:nth-child(3) {
        flex: 0 1 calc(72% - 5px);
    }

    > *:nth-child(4) {
        flex: 0 1 calc(28% - 5px);
    }

    > *:nth-child(5) {
        flex: 1 0 100%;
    }

    ${media.phone`
        > * {
            flex: 1 0 100% !important;
        }
    `}
`

const Success = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    text-align: center;

    font-family: 'GT America Expanded Bold';
    font-size: 20px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    padding: 0 28px;
    text-transform: uppercase;
    margin-top: 26px;
    box-sizing: border-box;

    ${media.phone`
        font-size: 14px;
        box-sizing: border-box; 
        line-height: 20px;
    `}
`

const Error = styled.div`
    width: 480px;
    max-width: 100%;
    margin-top: 80px;
    text-align: center;
    font-size: 20px;
    text-align: center;
    font-family: 'GT America Expanded Bold';
    text-transform: uppercase;

    ${media.phone`
        width: 241px;
    `} 
`

// Close

const Close = styled.div`
	position: absolute;
	right: 52px;
	top: 60px;
	background-image: url(${close});
	height: 20px;
	width: 20px;
	${bgIcon}
	${hoverState}

    ${media.phone`
        background-image: url(${close});
        top: 18px;
        right: 18px;
	`}
`	

const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: state.settings.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(Competition);



// WEBPACK FOOTER //
// ./src/components/Competition/Competition.js